import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

import getDisplayInformation from '../../data-driven-logo/get-display-information';
import DataDrivenLogoColumn from '../../columns/data-driven-logo-column';
import { messages } from '../messages';

const ProviderColumn = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const { labelProviderId } = labelFulfillment ?? {};

  if (!labelProviderId) {
    return '';
  }

  const providerId = Number.parseInt(labelProviderId, 10);
  const displayInformation = getDisplayInformation({ providerId });
  if (!displayInformation) {
    return '';
  }
  return <DataDrivenLogoColumn dataDrivenLogoProps={{ providerId }} message={displayInformation.name} />;
};

ProviderColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Provider = {
  getMessageDescriptor: () => messages.provider,
  id: 'provider',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <ProviderColumn fulfillmentId={data.id} />;
  },
};
